export default __webpack_public_path__ + "static/media/1.7d653304.png";